const DEFAULT_TIMEOUT_MS = 60_000;

export const parseStreamingTimeoutMs = (raw: unknown): number => {
  if (raw === undefined || raw === null || raw === "") {
    return DEFAULT_TIMEOUT_MS;
  }
  const parsed = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_TIMEOUT_MS;
  }
  return Math.floor(parsed);
};
